import type { JSX } from 'react';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { SecondaryNav } from '@feathr/components';
import { useNavigation } from '@feathr/extender/state';

import SettingsNav from '../PrimaryNav/SettingsNav';

interface ISettingsSecondaryNavProps {
  className?: string;
}

function SettingsSecondaryNav({ className }: Readonly<ISettingsSecondaryNavProps>): JSX.Element {
  const { t } = useTranslation();
  const { setActiveSecondaryNav, scrollableRef } = useNavigation();

  const handleBack = (): void => {
    setActiveSecondaryNav(null);
  };

  return (
    <SecondaryNav
      className={className}
      onBack={handleBack}
      scrollableRef={scrollableRef}
      title={t('Account Settings')}
    >
      <SettingsNav indented={false} />
    </SecondaryNav>
  );
}

export default SettingsSecondaryNav;
